// Installment Calculator Utility

export const calculateInstallment = (propertyPrice, tenor) => {
  const propertyPriceRupiah = propertyPrice * 1_000_000; // Convert to rupiah
  const downPayment = propertyPriceRupiah * 0.025; // 2.5% DP
  const loanAmount = propertyPriceRupiah - downPayment;
  const interest = 0.038;
  const months = tenor * 12;

  const monthlyPayment = (((loanAmount*interest*tenor)+loanAmount)/months)/1_000_000;

  
  // Simple interest calculation
  // const monthlyRate = 0.08 / 12; // 8% annual interest rate
  
  // Calculate monthly payment using loan formula
  // let monthlyPayment;
  // if (monthlyRate > 0) {
  //   monthlyPayment = loanAmount * (monthlyRate * Math.pow(1 + monthlyRate, months)) / (Math.pow(1 + monthlyRate, months) - 1);
  // } else {
  //   monthlyPayment = loanAmount / months;
  // }
  
  // const monthlyPaymentMillions = monthlyPayment / 1_000_000;
  
  return {
    monthly_payment: Math.round(monthlyPayment * 100) / 100,
    down_payment: Math.round((downPayment / 1_000_000) * 100) / 100,
    loan_amount: Math.round((loanAmount / 1_000_000) * 100) / 100,
    total_payment: Math.round((monthlyPayment * months) * 100) / 100
  };
};

export const formatPrice = (price) => {
  if (price >= 1000) {
    return `${(price / 1000).toFixed(price % 1000 === 0 ? 0 : 1)} M`;
  }
  return `${price} Jt`;
};
